import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LessonPageItemTypeService } from './networking/services/lesson-page-item-type.service';
import { LessonPageItemType } from './data/models/LessonPageItemType';
import { CommonModule } from '@angular/common';
import { finalize, from, Observable } from 'rxjs';
import { SharedDataService } from './helper/services/shared-data.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BottomBarComponent } from "./ui/bottom-bar/bottom-bar.component";
import { MatButtonModule } from '@angular/material/button'

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, CommonModule, MatProgressBarModule, BottomBarComponent, MatButtonModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent{

  constructor(public sharedDataService: SharedDataService) {}
}
